/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { isEmpty } from "lodash";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { TestimonialItemDisplay } from "./testimonial-card-item";

const TestimonialComponentDisplay = () => {
    const ctx = useContext(ContentZoneContext);
    const { component } = ctx || {};
    const { testimonial_list: testimonialList } = component;
    const hasContent = !isEmpty(testimonialList);
    return (
        <Fragment>
            <EmptyContentMessage hasContent={hasContent} component={component} />
            {hasContent && (
                <Fragment>
                    <div className="testimonial-display-content">
                        {testimonialList.map((item, index) => {
                            return <TestimonialItemDisplay key={index} item={item} />;
                        })}
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};
TestimonialComponentDisplay.displayName = "TestimonialComponentDisplay";
export { TestimonialComponentDisplay };
